// styles
import { Icon, LoadingIconContainer} from './LoadingIcon.styles.js';

export default function LoadingIcon() {
  return (
    <LoadingIconContainer>
        <Icon />
    </LoadingIconContainer>
  )
};